import CopyButton from 'components/Hero/CopyButton'
import { BiLock } from 'react-icons/bi'
import SyntaxHighlighter from 'react-syntax-highlighter/dist/esm/default-highlight'
import { vs2015 } from 'react-syntax-highlighter/dist/esm/styles/hljs'
import { CDN_BASE } from './constants'

function getCodeSnippet(widgetId) {
  return `<script>
  window.blandSettings = {
    widget_id: "${widgetId}",
  };
</script>
<script src="${CDN_BASE}/loader.js" defer></script>`
}

export default function CopyWidgetCode({ widgetId }) {
  const snippet = getCodeSnippet(widgetId || 'your-widget-id')

  return (
    <div className="relative top-0 w-full rounded-lg bg-[#0f0f17]">
      <div className="">
        <CopyButton
          value={snippet}
          displayText="Copy Code"
          className={`
            absolute top-0 right-0 z-10 flex items-center rounded-sm px-2.5
            py-1.5 text-white transition
          `}
        />
      </div>

      <div className={widgetId ? '' : 'blur-xs'}>
        <SyntaxHighlighter
          wrapLongLines
          language="javascript"
          style={vs2015}
          customStyle={{
            background: 'none',
            padding: '16px',
            margin: 0,
            fontSize: '12px',
            width: '100%',
          }}
        >
          {snippet}
        </SyntaxHighlighter>
      </div>

      {!widgetId && (
        <div className={`
          absolute inset-0 flex items-center justify-center rounded-lg
          bg-black/20 backdrop-blur-[1px]
        `}
        >
          <div className={`
            rounded-xl border border-white/10 bg-black/40 px-6 py-4 text-center
            text-white
          `}
          >
            <BiLock className="mx-auto mb-2 text-2xl text-white/70" />
            <p className="mb-1 text-sm font-medium">Widget Not Saved</p>
            <p className="text-xs text-white/70">Save your widget configuration to get the embed code</p>
          </div>
        </div>
      )}
    </div>
  )
}
